import Api from './Api'

class Tracking extends Api {

  constructor(version = 'v1') {
    super(version)
    this.path = 'trackings'
  }

}

export default Tracking


// WEBPACK FOOTER //
// ./src/api/Tracking.js